import React from 'react';


const Luma = () => {
    const handleClick = () => {
        window.open('https://lu.ma/', '_blank');
    };

    return (
        <button
            onClick={handleClick}
            className="w-12 h-12 bg-contain bg-no-repeat bg-center hover:scale-110 transition-opacity dark:invert"
            style={{ backgroundImage: "url('/arrow.svg')" }}
            aria-label="arrow"
        />
    );
};

export default Luma;